import React, { useEffect, useState } from "react";
import { MenuItem, Select, FormControl } from '@mui/material';
import { FieldErrors } from "../../../../../domain/helpers/Errors";
import { useLanguageStore } from "../../../../../store/useLanguageStore";
import { DocumentTemplateTypeEnum } from "../../../../../enums/documentTempateType";
import { DocumentTemplateInterface } from "../../../../../models/ProcurementModule/DocumentTemplate";
import { EditorState } from "draft-js";
import useDocumentTemplate from "../../../../../store/ReactQueries/general/documentTemplate/useDocumentTemplate";

type schemaType = "" | "RFQ" | "RFP" | "PR" | "PO";
interface TableSelectProps {
    errors: FieldErrors;
    disabledDropdown: boolean;
    selectSchema: schemaType;
    form: DocumentTemplateInterface;
    setEditorState: React.Dispatch<React.SetStateAction<EditorState>>;
    setSelectSchema: React.Dispatch<React.SetStateAction<schemaType>>;
    setForm: React.Dispatch<React.SetStateAction<DocumentTemplateInterface>>;
}

const TableSelect = ({ form, disabledDropdown, selectSchema, errors, setEditorState, setForm, setSelectSchema }: TableSelectProps) => {
    const { language } = useLanguageStore();
    const defaultTitles = ['RFQ', 'RFP', 'PR', 'PO'];
    const { data: documentTemplate } = useDocumentTemplate(1, 20);

    const [templateTitles, setTemplateTitles] = useState<string[]>(defaultTitles);

    useEffect(() => {
        if (documentTemplate && Array.isArray(documentTemplate)) {
            const existingTypes = documentTemplate.map(item => item.documentType);
            console.log('existingTypes', existingTypes);
            const filteredTitles = defaultTitles.filter(title => !existingTypes.includes(DocumentTemplateTypeEnum[title as "RFQ" | "RFP" | "PR" | "PO"]));
            console.log('filteredTitles', filteredTitles);
            setTemplateTitles(filteredTitles);
        }
    }, [documentTemplate]);

    const handleChange = (e: any) => {
        delete errors?.['title'];
        delete errors?.['documentType'];

        const result = e.target.value as schemaType;
        setSelectSchema(result);
        setEditorState(EditorState.createEmpty());
        setForm({
            ...form,
            title: result,
            documentType: DocumentTemplateTypeEnum[result as "RFQ" | "RFP" | "PR" | "PO"] ?? undefined,
            content: '',
        })
    }


    return <div className="d-flex flex-column">
        <div className="d-flex flex-row align-items-center gap-3">
            <label>{language['Table']}</label>
            {
                disabledDropdown
                    ? <span className="fw-bold">{selectSchema}</span>
                    : <FormControl variant="outlined" size="small" sx={{ width: 200 }}>
                        <Select
                            displayEmpty
                            value={selectSchema}
                            disabled={disabledDropdown}
                            inputProps={{ 'aria-label': 'Without label' }}
                            onChange={handleChange}
                            sx={{
                                '&.Mui-disabled': {
                                    color: 'black',
                                    '.MuiSelect-icon': {
                                        display: 'none',
                                    },
                                },
                            }}
                        >
                            <MenuItem value="">
                                <em>{language['Select']}</em>
                            </MenuItem>
                            {
                                templateTitles.map(item =>
                                    <MenuItem key={item} value={item}>{item}</MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
            }
        </div>
        {
            (errors?.['title'] || errors?.['documentType'])
            && <span style={{ fontSize: 12, color: 'red' }}>{errors?.['title'] ?? errors?.['documentType']}</span>
        }
    </div>
}

export default TableSelect;